export default __webpack_public_path__ + "static/diamond_b.10adf9cb8bf0768c8518937e35dfd75d.png";